export default __webpack_public_path__ + "static/media/food-blogger-section.b56a8449.webp";